import { MediaType } from '@app/store/shared/models';
import { MediaItemDto } from './media-item.dto';

export class MediaItem {
    readonly id: string;
    readonly name: string;
    readonly type: MediaType;
    readonly url: string;
    readonly fileName: string;
    readonly size: string;
    readonly createdAt: Date;

    constructor(dto: MediaItemDto) {
        this.id = dto.id;
        this.name = dto.name;
        this.type = dto.type;
        this.url = dto.url;
        this.fileName = dto.fileName;
        this.size = dto.size;
        this.createdAt = new Date(dto.createdAt);
    }
}
